import React from 'react';
import './UserFormSecurityTabs.css';

const TABS = [
  { id: 'geral', label: 'Geral' },
  { id: 'permissoes', label: 'Permissões' },
];

export function UserFormSecurityTabs({ value = 'geral', onChange, permissionsAttention = false }) {
  return (
    <div className="user-form-sec-tabs-bar">
      <nav className="user-form-sec-tabs" role="tablist" aria-label="Seções de segurança">
        {TABS.map((tab) => {
          const on = value === tab.id;
          const attention = tab.id === 'permissoes' && permissionsAttention;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={on}
              className={`user-form-sec-tab${on ? ' is-active' : ''}${attention ? ' is-attention' : ''}`}
              onClick={() => onChange?.(tab.id)}
            >
              <span className="user-form-sec-tab-label">{tab.label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}
